export default {
  SSR_GQL_ENDPOINT: process.env.SSR_GQL_ENDPOINT || 'http://localhost:5000/api',
  XAPI_ENDPOINT: process.env.XAPI_ENDPOINT || 'http://localhost:5001/xapi',
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja8.kuikr.com',
  STATIC_FILE_PATH: process.env.STATIC_FILE_PATH || 'clsfd',
  STATIC_DOMAIN: process.env.STATIC_DOMAIN || 'https://teja9.kuikr.com',
  APP_PORT: process.env.PORT || '3000',
  DOMAIN: process.env.DOMAIN || 'https://www.quikr.com',
  IDB_TIME: process.env.IDB_TIME || 7 * 24 * 60 * 60 * 1000,
  GA4_ID: process.env.GA4_ID || 'G-TDXMWQ59FL',
  TEMPORARY_REDIRECT_TIMEOUT: process.env.TEMPORARY_REDIRECT_TIMEOUT || 30 * 24 * 60 * 60 * 1000
};
